import Swiper from 'swiper/bundle';

const Testimonials = () => {
    const sliders = document.querySelectorAll('.testimonials__swiper');

    if (!sliders.length) return;

    sliders.forEach((slider) => {
        if (!(slider instanceof Element)) return;

        const swiperWrapper = slider.querySelector('.testimonials__swiper-wrapper');
        if (!swiperWrapper) return;

        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            effect: 'fade', // use fade instead of swipe
            fadeEffect: {
                crossFade: true, // smooth transition
            },
            speed: 1000, // transition duration in ms
            pagination: {
                el: slider.querySelector('.testimonials__pagination'),
                clickable: true,
            },
            navigation: {
                nextEl: slider.querySelector('.testimonials__nav--next'),
                prevEl: slider.querySelector('.testimonials__nav--prev'),
            },
        });
    });
};

export default Testimonials;
